<template>
  <router-view></router-view>
</template>
<script type="text/javascript">
export default {
  name: 'ServiceRequest'
}

</script>



// WEBPACK FOOTER //
// src/Osm/ServiceRequest/containers/ServiceRequest.vue